
import { FunctionComponent, useState } from "react";
import { Button } from "@mui/material";
import ModalFiltro from "../../../../../components/modalFiltros";
import { SelectBatismo } from "../../../../../components/selects/batismo";
import { SelectTarefa } from "../../../../../components/selects/tarefas";
import { StringNumber } from "../../../../../types";
import { SelectPresenca } from "../selects/presenca";
import { ParamsWith } from "../../services/services";


interface ModalFilterProps {
  getFilter: (e?: ParamsWith) => any
  reset: VoidFunction
}

const ModalFilter: FunctionComponent<ModalFilterProps> = ({ getFilter, reset }) => {

  const [idEventoBatismo, setIdEventoBatismo] = useState<StringNumber>();
  const [idTarefa, setIdTarefa] = useState<string>();
  const [presencaBatismo, setPresencaBatismo] = useState<boolean>(false);

  return (<>
    <ModalFiltro>
      <>
        <section
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 5,
            height: 50,
            borderBottom: '1px solid #ccc'
          }}
        >
          <h2 style={{ letterSpacing: '1.5px', fontWeight: '500', fontSize: 22 }}>Filtros</h2>
        </section>
        <SelectBatismo
          action={(event) => setIdEventoBatismo(event?.target?.value)}
          value={idEventoBatismo}
        />
        <SelectTarefa
          action={(event) => setIdTarefa(event?.target?.value)}
          idevento={idEventoBatismo}
          valor={idTarefa}
        />
        <SelectPresenca
          idevento={idEventoBatismo}
          idsubtarefa={idTarefa}
          action={(value) => setPresencaBatismo(value?.target?.value)}
          valor={presencaBatismo}
        />

        <section>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: '8px 0' }}>
            <Button
              onClick={() => { reset(); }}
              color="error"
              size="large"
              variant="contained"
            >
              Limpar
            </Button>
            <Button
              variant="contained"
              onClick={() => { getFilter({ idevento: idEventoBatismo, idsubevento: idTarefa, presenca: presencaBatismo }) }}
              size="large"
            >
              Enviar
            </Button>
          </div>
        </section>
      </>
    </ModalFiltro >
  </>);
}

export default ModalFilter;
